import type { CardFeatures } from '../../CardFeatures';
import { accountLinkage } from '../account-linkage/AT';
import { dynamicCurrencyConversion } from '../card-dynamic-currency-conversion/AT';
import { cardImage } from '../card-image/AT';
import { cardInsurance } from '../card-insurance/AT';
import { limitsChange } from '../card-limits-change/AT';
import { cardLimitsFocusPage } from '../card-limits-focus-page/AT';
import { limits } from '../card-limits/combined-limits/AT';
import { permanentLimitsLegacy } from '../card-limits/permanent-limits-legacy/AT';
import { permanentLimits } from '../card-limits/permanent-limits/AT';
import { temporaryLimits } from '../card-limits/temporary-limits/AT';
import { cardLockAndReplace } from '../card-lock-and-replace/AT';
import { cardLock } from '../card-lock/AT';
import { prepaidCardInfo } from '../card-prepaid-info/AT';
import {
    card3DSecureCode,
    card3DSecureCodeEncryption,
} from '../card-services/card-3d-secure-code/AT';
import { automaticCardReplacement } from '../card-services/card-automatic-replacement/AT';
import { cardCancellation } from '../card-services/card-cancellation/AT';
import { cardDelivery } from '../card-services/card-delivery/AT';
import { changeCardDesign } from '../card-services/card-design-change/AT';
import { cardLoyaltyProgramExternal } from '../card-services/card-loyalty-external/AT';
import { supplementaryCardInstallments } from '../card-services/supplementary-card-installments/AT';
import { cardMigrationExternal } from '../card-services/card-migration-external/AT';
import { creditCardReissueExternal } from '../card-services/card-reissue-external/AT';
import { cardReissue } from '../card-services/card-reissue/AT';
import { orderReplacementCard } from '../card-services/card-replacement/AT';
import { cardDetails, cardDetailsEncryption } from '../card-services/card-secured-details/AT';
import { changeCardDelivery } from '../card-services/delivery-management-v2/AT';
import { displayPin, displayPinEncryption } from '../card-services/display-pin/AT';
import { changePinDelivery } from '../card-services/pin-delivery-change/AT';
import { pinDeliveryFromCardDelivery } from '../card-services/pin-delivery-from-card-delivery/AT';
import { pinDelivery } from '../card-services/pin-delivery/AT';
import { reprintPinFocusPage } from '../card-services/reprint-pin-focus-page/AT';
import { reprintPin } from '../card-services/reprint-pin/AT';
import { cardTracking } from '../card-tracking/AT';
import { cardUnlock } from '../card-unlock/AT';
import { bankCardLimitChange } from '../cards-bank/card-limit-changes/AT';
import { cardLimitInfo } from '../cards-bank/card-limit-info/AT';
import { cardReplacement } from '../cards-bank/card-replacement/AT';
import { geoControl } from '../cards-bank/geo-control/AT';
import { linkedAccounts } from '../cards-bank/linked-accounts/AT';
import { microCardActivation } from '../cards-bank/micro-card-activation/AT';
import { microSticker } from '../cards-bank/micro-sticker/AT';
import { cardServices } from '../cards-credit/additional-services/AT';
import { cardFees } from '../cards-credit/card-fees/AT';
import { creditCardLimitChange } from '../cards-credit/card-limit-change/AT';
import { creditCardLimitInfo } from '../cards-credit/card-limit-info/AT';
import { creditCardMeter } from '../cards-credit/card-meter/AT';
import { creditCardDirectDebit } from '../cards-credit/direct-debit/AT';
import { creditCardPayUp } from '../cards-credit/pay-up/AT';
import { autoRepayment } from '../cards-credit/repayment/AT';
import { creditCardStatements } from '../cards-credit/statements/AT';
import { contactlessPayments } from '../contactless-payments/AT';
import { expirationTime } from '../expiration-time/AT';
import { installmentsActivation } from '../installments-activation/AT';
import { installments } from '../installments/AT';
import { temporaryDeactivation } from '../temporary-deactivation/AT';
import { topUp } from '../top-up/AT';
import { upcomingInstallments } from '../upcoming-installments/AT';

export const cards: CardFeatures = {
    accountLinkage,
    autoRepayment,
    bankCardLimitChange,
    card3DSecureCode,
    card3DSecureCodeEncryption,
    cardCancellation,
    cardDelivery,
    cardDetails,
    cardDetailsEncryption,
    cardFees,
    cardInsurance,
    cardLimitInfo,
    cardLock,
    cardLockAndReplace,
    cardLoyaltyProgramExternal,
    cardMigrationExternal,
    cardReissue,
    cardReplacement,
    cardServices,
    cardTracking,
    supplementaryCardInstallments,
    cardUnlock,
    changeCardDesign,
    contactlessPayments,
    creditCardLimitChange,
    creditCardLimitInfo,
    creditCardReissueExternal,
    creditCardStatements,
    displayPin,
    displayPinEncryption,
    dynamicCurrencyConversion,
    expirationTime,
    geoControl,
    installments,
    installmentsActivation,
    upcomingInstallments,
    limits,
    limitsChange,
    linkedAccounts,
    microCardActivation,
    microSticker,
    permanentLimits,
    permanentLimitsLegacy,
    pinDelivery,
    pinDeliveryFromCardDelivery,
    prepaidCardInfo,
    reprintPin,
    temporaryDeactivation,
    temporaryLimits,
    topUp,
    cardLimitsFocusPage,
    creditCardPayUp,
    reprintPinFocusPage,
    automaticCardReplacement,
    changePinDelivery,
    changeCardDelivery,
    creditCardDirectDebit,
    orderReplacementCard,
    creditCardMeter,
    cardImage,
    relyOnPAPIDataForCards: {
        enabled: false,
    },
    redesignedCardContentBox: {
        enabled: true,
    },
    redesignedDebitCardContentBox: {
        enabled: true,
    },
    additionalCreditCards: {
        enabled: false,
    },
    cardsTicketing: {
        enabled: true,
    },
    nativeCardOrder: {
        enabled: false,
    },
    nativeCardReplacement: {
        enabled: false,
    },
};
